import { useId } from "react";

export default function useSelectorId() {
   return useId().replaceAll(":", "-");
}
